module.exports = __webpack_public_path__ + "img/Haende_farbig.796101f.svg";